<template>
    <div class="bloco margem">
        <fieldset class="grid-3">
            <div>
                <label>Nome</label>
                <input type="text" v-model="protocolo.nome" @focusout="editarProtocolo('nome', protocolo.nome)"
                    :disabled="finalizado">
            </div>
            <div>
                <label>Setor Solicitante</label>
                <select v-model="protocolo.setor_id" :disabled="finalizado"
                    @change="editarProtocolo('setor_id', protocolo.setor_id)">
                    <option v-for="item in setores" :key="item.id" :value="item.id"
                        :style="{ 'font-weight': (item.nivel_hierarquico <= 2) ? 'bold' : '0' }">
                        <span v-if="item.nivel_hierarquico === 3" style="color: red;"> &nbsp;&nbsp; </span> {{
                            item.nivel_hierarquico === 3 ? "-" : '' }} {{ item.nome }}
                    </option>
                </select>
            </div>
            <div>
                <label>Setor Destinatário</label>
                <select v-model="protocolo.setorDestinatario_id" :disabled="finalizado"
                    @change="editarProtocolo('setorDestinatario_id', protocolo.setorDestinatario_id)">
                    <option v-for="item in setores" :key="item.id" :value="item.id"
                        :style="{ 'font-weight': (item.nivel_hierarquico <= 2) ? 'bold' : '0' }">
                        <span v-if="item.nivel_hierarquico === 3" style="color: red;"> &nbsp;&nbsp; </span> {{
                            item.nivel_hierarquico === 3 ? "-" : '' }} {{ item.nome }}
                    </option>
                </select>
            </div>
            <div>
                <label>Responsável</label>
                <select :disabled="finalizado" @change="editarProtocolo('responsavel_id', protocolo.responsavel_id)"
                    v-model="protocolo.responsavel_id">
                    <option v-for="item in gerente" :key="item.id" :value="item.id"> {{ item.nomeCompleto }} </option>
                </select>
            </div>
            <div>
                <label>Data da Criação</label>
                <input :disabled="finalizado" type="date" v-model="protocolo.dtInicio"
                    @change="editarProtocolo('dtInicio', protocolo.dtInicio)">
            </div>
            <div>
                <label>Data Prevista de Conclusão</label>
                <input :disabled="finalizado" type="date" v-model="protocolo.dtFimPrevisto"
                    @change="editarProtocolo('dtFimPrevisto', protocolo.dtFimPrevisto)">
            </div>
            <div>
                <table class="tabela">
                    <thead>
                        <tr>
                            <th style="text-align: left !important">Outros Responsáveis</th>
                            <th>Função</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="r in (protocolo.responsaveis || [])" :key="r.id">
                            <td style="text-align: left !important">{{ r.usuario_nome }}</td>
                            <td>
                                <input type="text" v-model="r.descricao" :disabled="finalizado"
                                    @blur="salvarOutrosResponsaveis">
                            </td>
                            <td><i v-if="!finalizado" class="bi bi-trash3" style="color: red; cursor: pointer;"
                                    title="Remover" @click="removerOutroResponsavel(r)"></i></td>
                        </tr>
                        <tr v-if="!finalizado">
                            <td colspan="3">
                                <select v-model="novoOutroResponsavelId" @change="adicionarOutroResponsavel">
                                    <option value="">Adicionar responsável</option>
                                    <option v-for="u in gerenteFiltradoOutrosResponsaveis" :key="u.id" :value="u.id">{{
                                        u.nomeCompleto }}</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-2">
                <label>Observações / Escopo</label>
                <textarea :readonly="finalizado" @focusout="editarProtocolo('obs', protocolo.obs)" style="height: 200px"
                    v-model="protocolo.obs"></textarea>
            </div>
            <div class="col-3"><label>Anexos: <i title="Adicionar anexo" v-if="!finalizado"
                        style="font-size: 15px; cursor: pointer; margin-left: 0.5rem;" class="bi bi-plus-circle"
                        @click="openFileInput"></i></label>
                <div class="grid-2">
                    <div class="anexo" v-for="anexo in anexos" :key="anexo.id">
                        <a :href="urlFoto.caminhoFoto + anexo.anexo" target="_blank"> {{ anexo.nome }}</a>
                        <i v-if="!finalizado" @click="excluirAnexo(anexo.id)" :id="'botaoExcluir' + anexo.id"
                            style="color: red" class="bi bi-trash-fill botaoAdicionarSprint"></i>
                    </div>
                </div>
                <input style="display: none;" ref="fileInput" type="file" @change="handleFileUpload">
            </div>
        </fieldset>
    </div>
    <br>
    <div class="bloco margem">
        <div class="row">
            <div style="width: 20%;">
                <div style="width: 10rem;">
                    <h5>
                        <span style="display: flex;">
                            <span class="hPoints bg-alerta">{{ somarHP(protocolo)[0] }}</span>
                            <span class="hPoints bg-ok">{{ somarHP(protocolo)[1] }}</span>
                            <span class="hPoints bg-sucesso">{{ somarHP(protocolo)[2] }}</span>
                        </span>
                    </h5>
                </div>
            </div>
        </div>
        <table :id="protocolo.nome" class="tabela">
            <tbody>
                <tr>
                    <th>
                        <strong> Código </strong>
                    </th>
                    <th>
                        <strong> Descrição </strong>
                    </th>
                    <th v-if="protocolo.tipo_id !== 8">
                        <strong> H.P. </strong>
                    </th>
                    <th>
                        <strong> Responsável </strong>
                    </th>
                    <th>
                        <strong> Início Previsto </strong>
                    </th>
                    <th>
                        <strong> Fim Previsto </strong>
                    </th>
                    <th style="padding: 0rem;">
                        <strong> Status </strong>
                    </th>
                    <th>
                    </th>
                </tr>
                <tr v-for="element in protocolo.tarefas" :key="element.id" :data-tarefa-id="element.id"
                    :class="{ 'destaque-tarefa': destaqueTarefaId && element.id === destaqueTarefaId }">
                    <td>
                        <span style="width: 100%; white-space: nowrap;">{{ element.codigo }}</span>
                    </td>
                    <td class="clicavel" style="text-align: left;">
                        <div @click="abrirModaleditarTarefa(element.id)" :title="element.descricao"
                            style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;">
                            <i v-if="element.anexos?.length" class="bi bi-paperclip" title="Esta tarefa possui anexo"
                                style="margin-right: 0.25rem;"></i>
                            {{ element.descricao }} </div>
                    </td>
                    <td class="clicavel" v-if="protocolo.tipo_id !== 8">
                        <select v-model="element.HP" class="HP" :disabled="finalizado"
                            @change="editarTarefa('HP', element.id, element.HP)"
                            style="width: 2.5rem; height: 2.5rem;text-align: center; border-radius: 50%; padding: 0;">
                            <option hidden>0</option>
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>5</option>
                            <option>8</option>
                            <option>13</option>
                            <option>21</option>
                            <option>34</option>
                            <option>55</option>
                            <option>89</option>
                            <option>144</option>
                            <option>233</option>
                        </select>
                    </td>
                    <td class="clicavel">
                        <select v-model="element.responsavel_id" :disabled="finalizado"
                            style="min-width: max-content; border: none; background-color: transparent;"
                            @change="editarTarefa('responsavel_id', element.id, element.responsavel_id)">
                            <option hidden>Responsável</option>
                            <option v-for="item in gerente" :key="item.id" :value="item.id"> {{
                                nomeEsobrenome(item.nomeCompleto) }} </option>
                        </select>
                    </td>
                    <td class="clicavel">
                        <input :readonly="finalizado"
                            style="cursor: pointer; width: 7rem; text-align: left; padding-inline: 0rem; border: none; background-color: transparent;"
                            type="date" @change="editarTarefa('dtInicio', element.id, element.dtInicio)"
                            v-model="element.dtInicio">
                    </td>
                    <td class="clicavel">
                        <div style="display: flex; align-items: center; gap: 5px;">
                            <input :readonly="finalizado"
                                style="cursor: pointer; width: 7rem; text-align: left; padding: 0rem; border: none; background-color: transparent;"
                                type="date" :min="element.dtInicio"
                                @change="editarTarefa('dtFim', element.id, element.dtFim)" v-model="element.dtFim">
                            <i v-if="isTarefaAtrasada(element)" class="bi-exclamation-diamond-fill txt-erro"
                                style="font-size: 18px;" title="Tarefa Atrasada"></i>
                        </div>
                    </td>
                    <td style="max-width: 14rem; min-width: 10.4rem ;padding: 0rem;">
                        <div style="position: relative;">
                            <v-progress-linear
                                :color="(element.status === 'Concluído') ? 'var(--cor-sucesso)' : (element.status === 'Pendente') ? 'var(--cor-alerta)' : (element.status === 'Em andamento' || element.status === 'Em andamento 25%' || element.status === 'Em andamento 50%' || element.status === 'Em andamento 75%') ? 'var(--cor-ok)' : 'red'"
                                :model-value="element.status === 'Concluído' ? 100 : element.status === 'Pendente' ? 100 : element.status.split(' ')[2] ? element.status.split(' ')[2].slice(0, 2) : 2"
                                style="border: 1px solid var(--cor-fonte-fraca); border-radius: 25px; height: 2rem;">
                            </v-progress-linear>
                            <select :title="element.status" :disabled="finalizado"
                                :style="{ 'color': (element.status === 'Concluído') ? 'var(--cor-bg)' : 'black' }"
                                style="border: none; padding-left: 0.5rem;position: absolute; top: 0; left: 0rem; outline: none; border-radius: 25px ;height: 2rem ;text-align: center; background-color: transparent; padding-top: 0rem; padding-bottom: 0rem;"
                                @focus="element.__prevStatus = element.status" @change="onChangeStatusTarefa(element)"
                                v-model="element.status">
                                <option value="" hidden></option>
                                <option style="color: rgb(255, 145, 0);" value="Pendente">A iniciar </option>
                                <option style="color: rgb(0, 47, 255);" :value="'Em andamento'">Em andamento 0%
                                </option>
                                <option style="color: rgb(0, 47, 255);">Em andamento 25%</option>
                                <option style="color: rgb(0, 47, 255);">Em andamento 50%</option>
                                <option style="color: rgb(0, 47, 255);">Em andamento 75%</option>
                                <option style="color: rgb(0, 192, 0);">Concluído</option>
                            </select>
                        </div>
                    </td>
                    <td>
                        <v-menu>
                            <template v-slot:activator="{ props }">
                                <v-btn
                                    style="width: 2rem; height: 2rem; background-color: transparent; border: 1px solid var(--cor-separador); color: var(--cor-fonte);"
                                    class="acao-secundaria botaoEditar" icon="mdi-dots-horizontal"
                                    v-bind="props"></v-btn>
                            </template>
                            <v-list style="background-color: var(--cor-bg); color: var(--cor-fonte);">
                                <v-list-item style="margin: 0.2rem;" :disabled="finalizado"
                                    @click="abrirModaleditarTarefa(element.id)"> Editar
                                    Tarefa </v-list-item>
                                <v-list-item :disabled="finalizado">
                                    <v-menu>
                                        <template v-slot:activator="{ props }">
                                            <span style="color: red;margin: 0.2rem; cursor: pointer;"
                                                v-bind="props">Excluir Tarefa</span>
                                        </template>
                                        <v-list style="background-color: var(--cor-bg); color: var(--cor-fonte);">
                                            <v-list-item>
                                                <div>
                                                    <h3>Tem certeza? Esta ação é Irreversível!</h3>
                                                    <div class="submit">
                                                        <Button @click="apagarTarefa(element.id)">Excluir</Button>
                                                        <button class="acao-secundaria">Cancelar</button>
                                                    </div>
                                                </div>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </td>
                </tr>
            </tbody>
        </table>
        <br>
        <div style="display: flex; padding-left: 0.2rem; border-radius: 5px; width: 100%;" v-if="!finalizado"
            :id="protocolo.id">
            <div
                style="border: 1px solid var(--cor-separador); border-radius: 5px; padding: 0.3rem; width: 6rem; align-content: center ;text-align: center;">
                <strong>
                    {{ codigoNovaTarefa }} </strong>
            </div>
            <div
                style="border: 1px solid var(--cor-separador); border-radius: 5px; width: 100%; margin-left: 0.3rem; padding: 0.3rem;">
                <input type="text" placeholder="O que será feito?"
                    @keyup.enter="criarTarefa($event.target.value), $event.target.value = ''"
                    style="width: 100%; padding: 0.1rem; padding-left: 0.5rem; outline: none; height: 2rem; border: none;"
                    :id="'inputNovaTarefa' + protocolo.id">
            </div>
        </div>
    </div>
    <ModalEditarTarefaProtocolo :mostrar="showeditarTarefa" :tarefa="backlogeditado" :gerente="gerente"
        :finalizado="finalizado" @fechar="showeditarTarefa = false" @editar="editarTarefa"
        @excluir-anexo="excluirAnexoTarefa" @upload-anexos="uploadAnexoTarefa" />
    <ModalConfirmarConcluirProtocolo :mostrar="showConfirmConcluirProtocolo" :protocolo="protocolo"
        @fechar="confirmarConclusaoProtocolo(false)" @confirmar="confirmarConclusaoProtocolo(true)" />
    <button v-if="protocolo.id && protocolo.status !== 'Concluído'"
        :disabled="protocolo.tarefas?.some(tarefa => tarefa.status !== 'Concluído')"
        class="btn-concluir-protocolo-fixo acao-secundaria bg-sucesso"
        :title="protocolo.tarefas?.some(tarefa => tarefa.status !== 'Concluído') ? 'Todas as tarefas devem estar concluídas' : 'Concluir protocolo'"
        @click="abrirModalConcluirProtocolo">
        Concluir protocolo
    </button>
</template>
<script>
import { ref } from 'vue';
import { urlFoto } from "@/services/api";
import { dataHoraAgora } from "@/utils/date";
import { useApiError } from "@/composables/useApiError";
import { consultarSetores } from "@/services/usuario-setor";
import { sso } from "roboflex-thalamus-sso-lib";
import serviceFunções from "@/services/serviceFunções";
import { getPermissao } from "@/services/permissao-service";
import serviceProtocolo from "@/services/serviceProtocolo";
import ModalEditarTarefaProtocolo from "@/components/Modais/protocolos/ModalEditarTarefaProtocolo.vue";
import ModalConfirmarConcluirProtocolo from "@/components/Modais/protocolos/ModalConfirmarConcluirProtocolo.vue";

export default {
    name: "ProtocoloComponent",
    components: { ModalEditarTarefaProtocolo, ModalConfirmarConcluirProtocolo },
    props: {
        propProtocolo: {
            required: true
        },
        destaqueTarefaId: { type: [Number, String], default: null },
    },

    computed: {
        finalizado() {
            if (this.funcionalidades.includes(118)) {
                return false
            } else {
                return this.protocolo.status === 'Concluído'
            }
        },
        codigoNovaTarefa() {
            return 'Tarefa - ' + (this.protocolo?.tarefas?.length + 1) ?? 'Tarefa - 1'
        },
        gerenteFiltradoOutrosResponsaveis() {
            const idsIncluidos = (this.protocolo?.responsaveis || []).map((r) => r.usuario_id)
            return (this.gerente || []).filter((u) => !idsIncluidos.includes(u.id))
        },
        hoje() {
            const d = new Date();
            const Y = d.getFullYear();
            const M = String(d.getMonth() + 1).padStart(2, '0');
            const D = String(d.getDate()).padStart(2, '0');
            return `${Y}-${M}-${D}`;
        },
    },
    setup() {
        const fileInput = ref(null);

        const openFileInput = () => {
            fileInput.value.click();
        };

        const somarHP = (dados) => {
            return serviceFunções.somarHP2(dados);
        };

        const nomeEsobrenome = (nome) => {
            return serviceFunções.nomeEsobrenome(nome);
        };

        const { handleError } = useApiError();
        return { fileInput, openFileInput, urlFoto, somarHP, nomeEsobrenome, handleApiError: handleError };
    },

    data() {
        return {
            protocolo: {},
            gerente: [],
            idUsuario: null,
            showeditarTarefa: false,
            anexos: null,
            funcionalidades: [],
            setores: null,

            showConfirmConcluirProtocolo: false,
            tarefaEmConfirmacao: null,
            novoOutroResponsavelId: '',
            novoOutroResponsavelDescricao: '',
        }
    },

    created() {
        const usuarioLogado = sso.getUsuarioLogado()
        this.idUsuario = usuarioLogado.id
    },

    async mounted() {
        this.protocolo = this.propProtocolo;
        this.anexos = this.propProtocolo.anexos
        this.getGerenteseSetor()
        this.funcionalidades = await getPermissao();
        if (this.destaqueTarefaId) {
            this.$nextTick(() => this.aplicarDestaqueTarefa());
        }
    },

    methods: {
        isTarefaAtrasada(tarefa) {
            if (!tarefa?.dtFim || tarefa.status === 'Concluído' || tarefa.status === 'Cancelada') return false;
            const dtFim = String(tarefa.dtFim).slice(0, 10);
            return this.hoje > dtFim;
        },
        aplicarDestaqueTarefa() {
            const id = this.destaqueTarefaId ? String(this.destaqueTarefaId) : null;
            if (!id) return;
            const limparQuery = () => {
                if (this.$route?.query?.destaque_tarefa_id != null) {
                    const query = { ...this.$route.query };
                    delete query.destaque_tarefa_id;
                    this.$router.replace({ path: this.$route.path, params: this.$route.params, query: Object.keys(query).length ? query : undefined });
                }
            };
            const tentarScroll = (tentativa = 0) => {
                const el = this.$el?.querySelector?.(`tr[data-tarefa-id="${id}"]`);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    setTimeout(limparQuery, 3000);
                    return;
                }
                if (tentativa < 25) {
                    setTimeout(() => tentarScroll(tentativa + 1), 150);
                } else {
                    setTimeout(limparQuery, 500);
                }
            };
            this.$nextTick(() => tentarScroll(0));
        },
        async handleFileUpload() {
            const fileInput = this.$refs.fileInput;

            if (fileInput && fileInput.files.length > 0) {
                const formData = new FormData();
                formData.append('protocolo_id', this.protocolo.id);

                for (let i = 0; i < fileInput.files.length; i++) {
                    formData.append('anexos[]', fileInput.files[i]);
                }

                try {
                    const data = await serviceProtocolo.atualizarProtocoloComFormData(this.protocolo.id, formData);
                    if (data?.anexos_salvos?.[0]) {
                        const a = data.anexos_salvos[0];
                        this.anexos.push({ path: a.path, nome: a.nome, id: a.id });
                    }
                } catch (error) {
                    this.handleApiError(error);
                }
            }

        },

        async getGerenteseSetor() {
            try {
                const { usuarios, setores } = await consultarSetores();
                this.gerente = usuarios;
                this.setores = setores
            } catch (error) {
                this.handleApiError(error);
            }
        },

        payloadOutrosResponsaveis() {
            return (this.protocolo?.responsaveis || []).map((r) => ({
                usuario_id: r.usuario_id,
                descricao: r.descricao || null,
            }))
        },
        async salvarOutrosResponsaveis() {
            const payload = this.payloadOutrosResponsaveis()
            try {
                await serviceProtocolo.editarProtocolo(this.protocolo.id, 'responsaveis', payload, this.idUsuario)
            } catch (error) {
                this.handleApiError(error)
            }
        },
        adicionarOutroResponsavel() {
            if (!this.novoOutroResponsavelId) return
            const user = this.gerente.find((u) => Number(u.id) === Number(this.novoOutroResponsavelId))
            if (!user) return
            if (!this.protocolo.responsaveis) this.protocolo.responsaveis = []
            this.protocolo.responsaveis.push({
                id: null,
                usuario_id: user.id,
                usuario_nome: user.nomeCompleto,
                descricao: this.novoOutroResponsavelDescricao || '',
            })
            this.novoOutroResponsavelId = ''
            this.novoOutroResponsavelDescricao = ''
            this.salvarOutrosResponsaveis()
        },
        removerOutroResponsavel(r) {
            this.protocolo.responsaveis = (this.protocolo.responsaveis || []).filter((x) => x !== r)
            this.salvarOutrosResponsaveis()
        },

        async excluirAnexo(id) {
            try {
                await serviceProtocolo.excluirAnexoProtocolo(id);
                this.anexos = this.anexos.filter((anexo) => anexo.id !== id);
            } catch (error) {
                this.handleApiError(error);
            }
        },


        abrirModaleditarTarefa(idProtocolo) {
            this.showeditarTarefa = true;
            const tarefa = this.protocolo.tarefas.find(tarefa => tarefa.id === idProtocolo);
            if (tarefa && !Array.isArray(tarefa.anexos)) {
                tarefa.anexos = [];
            }
            this.backlogeditado = tarefa;
        },

        async uploadAnexoTarefa(files) {
            if (!this.backlogeditado?.id || !files?.length) return;

            const formData = new FormData();
            formData.append('protocoloTarefa_id', this.backlogeditado.id);
            for (let i = 0; i < files.length; i++) {
                formData.append('anexos[]', files[i]);
            }

            try {
                const data = await serviceProtocolo.adicionarAnexoTarefa(formData);
                if (!Array.isArray(this.backlogeditado.anexos)) {
                    this.backlogeditado.anexos = [];
                }
                (data?.anexos_salvos || []).forEach((a) => {
                    this.backlogeditado.anexos.push({
                        id: a.id,
                        nome: a.nome,
                        path: a.path,
                        anexo: a.path,
                    });
                });
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async excluirAnexoTarefa(idAnexo) {
            try {
                await serviceProtocolo.excluirAnexoProtocolo(idAnexo);
                if (this.backlogeditado?.anexos) {
                    this.backlogeditado.anexos = this.backlogeditado.anexos.filter((a) => a.id !== idAnexo);
                }
            } catch (error) {
                this.handleApiError(error);
            }
        },

        editarProtocolo(itemAlterado, novoValor) {
            serviceProtocolo.editarProtocolo(this.protocolo.id, itemAlterado, novoValor, this.idUsuario);
        },

        editarTarefa(itemAlterado, idTarefa, novoValor) {
            var payload = {
                [itemAlterado]: novoValor,
                usuario_id: this.idUsuario,
            }
            serviceProtocolo.editarTarefa(idTarefa, payload);

            // Mantém o estado local sincronizado (o modal edita uma cópia em localTarefa)
            const tarefa = this.protocolo.tarefas?.find((t) => t.id === idTarefa);
            if (tarefa) {
                const camposData = ['dtInicio', 'dtFim', 'dtInicioReal', 'dtFimReal'];
                if (camposData.includes(itemAlterado) && typeof novoValor === 'string' && novoValor.includes(' ')) {
                    tarefa[itemAlterado] = novoValor.split(' ')[0];
                } else {
                    tarefa[itemAlterado] = novoValor;
                }
            }

            if (itemAlterado === 'status') {
                this.definirDatasReais(idTarefa, novoValor)
            }
        },

        definirDatasReais(idTarefa, status) {

            const dataHora = dataHoraAgora();
            let payload = { usuario_id: this.idUsuario };

            if (['Em andamento', 'Em andamento 25%', 'Em andamento 50%', 'Em andamento 75%'].includes(status)) {
                payload.dtInicioReal = dataHora;
                payload.dtFimReal = null;
            } else if (status === 'Concluído') {
                payload.dtFimReal = dataHora;
            } else if (status === 'Pendente') {
                payload.dtInicioReal = null;
                payload.dtFimReal = null;
            }

            if (Object.keys(payload).length > 1) {
                serviceProtocolo.editarTarefa(idTarefa, payload)
            }
        },

        async criarTarefa(descricao) {
            var payload = {
                descricao: descricao,
                protocolo_id: this.protocolo.id,
                status: 'Pendente'
            }

            var response = await serviceProtocolo.adicionarTarefa(payload)
            this.protocolo.tarefas.push({ ...response, anexos: response.anexos || [] })
        },

        async apagarTarefa(idTarefa) {
            await serviceProtocolo.excluirTarefa(idTarefa, this.idUsuario)
            this.protocolo.tarefas = this.protocolo.tarefas.filter(i => i.id !== idTarefa)

        },

        async onChangeStatusTarefa(element) {
            const novoStatus = element.status;
            // const prevStatus = element.__prevStatus || 'Pendente';

            if (novoStatus === 'Concluído') {
                // Todas ficariam concluídas após esta mudança?
                // const todasConcluidasApos = this.protocolo.tarefas.every(t =>
                //     t.id === element.id ? true : t.status === 'Concluído'
                // );

                // if (todasConcluidasApos) {
                //     // Mantém fluxo de confirmação de conclusão do protocolo
                //     this.tarefaEmConfirmacao = {
                //         id: element.id,
                //         novoStatus,
                //         refElemento: element,
                //         prevStatus
                //     };
                //     this.showConfirmConcluirProtocolo = true;
                //     return;
                // }

                // Verifica se esta é a primeira tarefa concluída
                const haviaAlgumaConcluidaAntes = this.protocolo.tarefas.some(t =>
                    t.id === element.id ? false : t.status === 'Concluído'
                );

                this.definirDatasReais(element.id, novoStatus);
                this.editarTarefa('status', element.id, novoStatus);

                // Se não havia concluídas antes, coloca o protocolo em "Em andamento"
                if (!haviaAlgumaConcluidaAntes && this.protocolo.status !== 'Em andamento') {
                    this.protocolo.status = 'Em andamento';
                    this.editarProtocolo('status', 'Em andamento');
                }
                return;
            }

            const entrouEmAndamento =
                novoStatus === 'Em andamento' ||
                novoStatus.startsWith('Em andamento');

            if (entrouEmAndamento) {
                const haviaAlgumaEmAndamentoAntes = this.protocolo.tarefas.some(t =>
                    t.id === element.id
                        ? false
                        : (t.status === 'Em andamento' || t.status.startsWith('Em andamento'))
                );

                this.definirDatasReais(element.id, novoStatus);
                this.editarTarefa('status', element.id, novoStatus);

                if (!haviaAlgumaEmAndamentoAntes && this.protocolo.status !== 'Em andamento') {
                    this.protocolo.status = 'Em andamento';
                    this.editarProtocolo('status', 'Em andamento');
                }
                return;
            }

            this.definirDatasReais(element.id, novoStatus);
            this.editarTarefa('status', element.id, novoStatus);
        },


        abrirModalConcluirProtocolo() {
            this.tarefaEmConfirmacao = null;
            this.showConfirmConcluirProtocolo = true;
        },
        async confirmarConclusaoProtocolo(confirmou) {
            const ctx = this.tarefaEmConfirmacao;
            this.showConfirmConcluirProtocolo = false;
            this.tarefaEmConfirmacao = null;

            if (!confirmou) {
                if (ctx) {
                    const { refElemento, prevStatus } = ctx;
                    refElemento.status = prevStatus;
                }
                return;
            }

            if (ctx) {
                const { id, novoStatus } = ctx;
                this.definirDatasReais(id, novoStatus);
                this.editarTarefa('status', id, novoStatus);
            }

            if (this.protocolo.status !== 'Concluído') {
                this.protocolo.status = 'Concluído';
                this.editarProtocolo('dtfim', dataHoraAgora());
                this.editarProtocolo('status', 'Concluído');
            }
        },

    }
}
</script>
<style scoped>
.botaoEditar {
    visibility: hidden;
}

tr:hover {
    .botaoEditar {
        visibility: visible;
    }
}

:disabled {
    opacity: 1;
    cursor: not-allowed;
}

.divAnexos {
    padding: 0.5rem;
    border: 1px solid var(--cor-separador);
    height: 3rem;
    border-radius: 6px;
    background-color: var(--cor-bg);
}

tr.destaque-tarefa {
    background-color: var(--cor-primaria-fraca, rgba(25, 118, 210, 0.15)) !important;
    animation: destaque-tarefa-pulse 1.5s ease-in-out 2;
}

@keyframes destaque-tarefa-pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.85;
    }
}

.btn-concluir-protocolo-fixo {
    position: fixed;
    bottom: 1.5rem;
    right: 5.5rem;
    z-index: 1000;
    background-color: var(--cor-sucesso);
}

.btn-concluir-protocolo-fixo:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>